import React from "react";

function DealCard({ deal }) {
  // Calcul automatique du pourcentage si "discount" n'est pas rempli dans deals.js
  const autoDiscount = deal.oldPrice 
    ? Math.round(((deal.oldPrice - deal.newPrice) / deal.oldPrice) * 100) 
    : deal.discount;

  return (
    <div style={styles.card} className="deal-card-hover">
      {/* Affiche le badge seulement s'il y a une réduction */}
      {autoDiscount > 0 && (
        <div style={styles.discount}>-{autoDiscount}%</div>
      )}

      <img src={deal.image} alt={deal.title} style={styles.image} />
      
      <div style={styles.content}>
        <h3 style={styles.title}>{deal.title}</h3>

        <div style={styles.prices}>
          {deal.oldPrice && <span style={styles.oldPrice}>{deal.oldPrice}$</span>}
          <span style={styles.newPrice}>{deal.newPrice}$</span>
        </div>

        <a href={deal.link} target="_blank" rel="noopener noreferrer" style={styles.button}>
          Profiter de l'offre
        </a>
      </div>
    </div>
  );
}

const styles = {
  card: { background: "#1a1a1a", borderRadius: "15px", overflow: "hidden", position: "relative", border: "1px solid #333" },
  discount: { position: "absolute", top: "10px", left: "10px", background: "#ff003c", color: "white", padding: "5px 12px", borderRadius: "8px", fontWeight: "bold", zIndex: 2 },
  image: { width: "100%", height: "180px", objectFit: "cover" },
  content: { padding: "15px" },
  title: { fontSize: "1.1rem", marginBottom: "10px", color: "white" },
  prices: { marginBottom: "15px", display: "flex", alignItems: "center", gap: "10px" },
  oldPrice: { textDecoration: "line-through", color: "#888", fontSize: "0.9rem" },
  newPrice: { color: "#00ffcc", fontSize: "1.3rem", fontWeight: "bold" },
  button: { display: "block", textAlign: "center", background: "#00ffcc", padding: "10px", borderRadius: "8px", color: "#000", fontWeight: "bold", textDecoration: "none" }
};

export default DealCard;